module.exports = __webpack_public_path__ + "media/images/mobile/Mask Group 8-fa972144500138f6410229686994be91.png";